import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation } from 'react-query';

interface CopyVINReelData {
  vin: string;
  videoTitle: string;
}

const copyVINReel = async (body: CopyVINReelData) => {
  return (await EXPRESS_API.post('/vinreels/videos', body)).data;
};

export const useCopyVINReelMutation = ({
  onSuccessCallback,
}: {
  onSuccessCallback?: () => void;
}) => {
  const { showError } = useToastError();
  return useMutation(copyVINReel, {
    onSuccess: () => {
      successToast({ title: 'VINReel has been added to Video library.' });
      if (onSuccessCallback) {
        onSuccessCallback();
      }
    },
    onError: err => {
      showError(err);
    },
  });
};
